import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../appState.interface";

export const franchiseState = (state: AppStateInterface) =>
  state.franchiseState;

export const resultFranchiseInfoSelector = createSelector(
  franchiseState,
  (state) => state.franchiseInfo
);

export const updateFranchiseProfileSuccessSelector = createSelector(
  franchiseState,
  (state) => state.success
);

export const resultFranchisedCompanyNamesByFranchiseSelector = createSelector(
  franchiseState,
  (state) => state.franchisedNamesList
);
export const resultMainDashboardSelector = createSelector(
  franchiseState,
  (state) => state.franchiseMainDashboardDto
);

export const resultTopFranchisedSelector = createSelector(
  franchiseState,
  (state) => state.topFranchised
)

export const resultFranchiseListSelector = createSelector(
  franchiseState,
  (state) => state.franchiseList
)
export const resultLoadingSelector = createSelector(
  franchiseState,
  (state) => state.loading
);

export const resultPaymentDetailsSelector = createSelector(
  franchiseState,
  (state) => state.paymentDetails
);

export const franchiseResultSelector = createSelector(
  franchiseState,
  (state) => state.franchisesResult
);

export const franchisesComapyNamesSelector = createSelector(
  franchiseState,
  (state) => state.companyNames
);

export const createFranchiseSuccessSelector = createSelector(
  franchiseState,
  (state) => state.success
);

export const updateFranchiseSuccessSelector = createSelector(
  franchiseState,
  (state) => state.success
);

export const deleteFranchiseSuccessSelector = createSelector(
  franchiseState,
  (state) => state.success
);

export const franchiseLocationsResultSelector = createSelector(
  franchiseState,
  (state) => state.franchisedList
);

export const comparatorResultSelector = createSelector(
  franchiseState,
  (state) => state.comparatorResults
)

export const loadingFranchiseComparatorSelector = createSelector(
  franchiseState,
  (state) => state.loading
);

export const resultLoadingMainDashboardSelector = createSelector(
  franchiseState,
  (state) => state.loadingMainDashboard
)
